export const modalPalette = <const>['basic', 'danger'];
export type ModalPalette = typeof modalPalette[number];
